import { AppImages } from 'components';
import { useContext, useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import * as AppPics from 'assets/images';
import { AuthContext } from 'context/AuthContext';
import { UserContext } from 'context/UserContext';
import { FetchContext } from 'context/FetchContext';
import CoursesSubLinks from './CoursesSubLinks';
import { ROLES } from 'utilities/constants';
import avatarSvg from './avatar.svg';
import {
  FaBell,
  FaHeadset,
  FaQuestionCircle,
  FaSyncAlt,
  FaExclamationCircle,
} from 'react-icons/fa';
import useRefundStats from 'hooks/API/GET/useRefundStats';

function SideBar() {
  const authContext = useContext(AuthContext);
  const { userInfo = {} } = useContext(UserContext);
  const { privateFetch } = useContext(FetchContext);
  const { data = {} } = userInfo || {};
  const { permission = [], name, avatarFullUrl, key } = data || {};
  const location = useLocation();

  const lessonReportPaths = ['/manage/lesson-issues', '/manage/lesson-feedback'];
  const isLessonReportActive = lessonReportPaths.some((p) => location.pathname.startsWith(p));
  const [lessonReportOpen, setLessonReportOpen] = useState(isLessonReportActive);

  /** Pending refund count shown as a badge on the sidebar link */
  const [pendingRefundCount, setPendingRefundCount] = useState(0);

  const { data: refundData } = useRefundStats({
    enabled: true, // or conditionally: !!privateFetch
  });

  useEffect(() => {
    const stats = refundData?.data || {};
    setPendingRefundCount(stats.pending || 0);
  }, [refundData]);

  const [hideSideMenu, toggleSideMenu] = useState(false);
  const toggleSideMenuSection = () => {
    toggleSideMenu(!hideSideMenu);
    if (!hideSideMenu) document.body.classList.add('mini');
    if (hideSideMenu) document.body.classList.remove('mini');
  };
  return (
    <header className={`${hideSideMenu ? 'mini' : ''}`}>
      {/* <!-- For Mini Menu for PC & also for mobile(< 600) default put this class ## <header className="mini"> --> */}
      <div className="logoWrap">
        <span className="logoWrap__logo">
          <AppImages alt="Edpodia Logo" src={AppPics.EdpodiaLogoSvg} />
        </span>
        <span className="logoWrap__menuToggle" onClick={() => toggleSideMenuSection()}>
          <AppImages alt="Click to hide side menu" src={AppPics.MenuToggleSvg} />
        </span>
      </div>
      <ul className="menuWrap">
        <li>
          <NavLink to="/console" className="menuWrap__menu" activeClassName="active">
            <img src={AppPics.DashboardLinkSvg} alt="" />
            <span className="menuWrap__menuName">Dashboard</span>
          </NavLink>
        </li>
        <li>
          <CoursesSubLinks />
        </li>
        {ROLES.ADMIN.toLowerCase() === data?.key.toLowerCase() && (
          <>
            <li>
              <NavLink to="/plans" className="menuWrap__menu" activeClassName="active">
                <img src={AppPics.SideMenuPlansSvg} alt="" />
                <span className="menuWrap__menuName">Plans</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/courses/bundles" className="menuWrap__menu" activeClassName="active">
                <img src={AppPics.SideMenuCourseBundleSvg} alt="" />
                <span className="menuWrap__menuName">Course bundles</span>
              </NavLink>
            </li>
            <li>
              <a className="menuWrap__menu" href="#">
                <img src={AppPics.LiveLinkSvg} alt="" />
                <span className="menuWrap__menuName">Live Classes</span>
              </a>
            </li>

            <li>
              <NavLink to="/support/ticket" className="menuWrap__menu" href="#">
                <img src={AppPics.SupportLinkSvg} alt="" />
                <span className="menuWrap__menuName">Support Tickets</span>
              </NavLink>
            </li>
            {/* <li>
              <a className="menuWrap__menu" href="#">
                <img src={AppPics.TimelineLinkSvg} alt="" />
                <span className="menuWrap__menuName">Timeline</span>
                <span className="menuWrap__menuIndi">5</span>
              </a>
            </li> */}
            <li>
              <NavLink to="/admin-centre" className="menuWrap__menu" activeClassName="active">
                <img src={AppPics.AdminLinkSvg} alt="" />
                <span className="menuWrap__menuName">Admin Centre</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/manage/requests" className="menuWrap__menu" activeClassName="active">
                <img src={AppPics.SupportLinkSvg} alt="" />
                <span className="menuWrap__menuName">Email requests</span>
              </NavLink>
            </li>
          </>
        )}
        <li>
          <NavLink to="/users/reviews" className="menuWrap__menu" activeClassName="active">
            <img src={AppPics.ValidateSvg} alt="" />
            <span className="menuWrap__menuName">Reviews</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/curriculum" className="menuWrap__menu" activeClassName="active">
            <img src={AppPics.AcademicCapSvg} alt="" />
            <span className="menuWrap__menuName">Manage Curriculum</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/doubtclearance" className="menuWrap__menu" activeClassName="active">
            <img src={AppPics.DoubtLinkSvg} alt="" />
            <span className="menuWrap__menuName">Doubt Clearance</span>
            {/* <span className="menuWrap__menuIndi">12</span> */}
          </NavLink>
        </li>
        <li>
          <NavLink to="/podcast" className="menuWrap__menu" activeClassName="active">
            <img src={AppPics.SideMenuPodcastSvg} alt="" />
            <span className="menuWrap__menuName">Podcast</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/users/timeline" className="menuWrap__menu" activeClassName="active">
            <img src={AppPics.TimelineLinkSvg} alt="" />
            <span className="menuWrap__menuName">Activity</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/support/category" className="menuWrap__menu" activeClassName="active">
            {/* <img src={AppPics.TimelineLinkSvg} alt="" /> */}
            <FaQuestionCircle size={22} color="#37D4D2" />
            <span className="menuWrap__menuName">Help Center</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/manage/notifications" className="menuWrap__menu" activeClassName="active">
            {/* <img src={AppPics.TimelineLinkSvg} alt="" /> */}
            <FaBell size={22} color="#37D4D2" />
            <span className="menuWrap__menuName">Notification</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/manage/refunds" className="menuWrap__menu" activeClassName="active">
            <FaSyncAlt size={22} color="#37D4D2" />
            <span className="menuWrap__menuName">
              Refunds
              {pendingRefundCount > 0 && (
                <span
                  className="menuWrap__menuIndi"
                  style={{
                    display: 'inline-block',
                    marginLeft: '6px',
                    background: '#f59e0b',
                    color: '#fff',
                    borderRadius: '10px',
                    fontSize: '0.7rem',
                    padding: '1px 6px',
                    fontWeight: 700,
                  }}
                >
                  {pendingRefundCount}
                </span>
              )}
            </span>
          </NavLink>
        </li>
        <li>
          <button
            className={`menuWrap__menu${isLessonReportActive ? ' active' : ''}`}
            style={{ border: 'none', width: '100%', textAlign: 'left', cursor: 'pointer' }}
            onClick={() => setLessonReportOpen((o) => !o)}
          >
            <FaExclamationCircle size={22} color="#37D4D2" />
            <span className="menuWrap__menuName">Lesson Reports</span>
          </button>
          <ul className={`menuWrap__menuSub ${lessonReportOpen ? '' : 'd-none'}`}>
            <li className={location.pathname.startsWith('/manage/lesson-issues') ? 'active' : ''}>
              <NavLink to="/manage/lesson-issues">Issues</NavLink>
            </li>
            <li className={location.pathname.startsWith('/manage/lesson-feedback') ? 'active' : ''}>
              <NavLink to="/manage/lesson-feedback">Feedback</NavLink>
            </li>
          </ul>
        </li>
        {/* </ul> */}
        {/* <ul className="menuWrap"> */}
        {/* {permission.map((menu) => {
          return (
            <li key={menu.identity}>
              <NavLink to={menu.url} className="menuWrap__menu" activeClassName="active">
                <AppImages alt="Go to dashboard" src={ImageIcon(menu.moduleIcon)} />
                <span className="menuWrap__menuName">{menu.name}</span>
              </NavLink>
            </li>
          );
        })} */}
      </ul>
      <div className="footWrap">
        <span className="footWrap__rights">&copy; {new Date().getFullYear()} QBIQ STUDIOS LLP</span>
        <div>
          <button type="button" className="footWrap__anchor" onClick={authContext.logout}>
            <AppImages alt="Click to Logout" src={AppPics.LogoutSvg} />
            <span>Logout</span>
          </button>
          <span className="footWrap__profile">
            <img src={avatarFullUrl || avatarSvg} alt="dp" />
            <strong>{name}</strong>
          </span>
        </div>
      </div>
    </header>
  );
}

function ImageIcon(iconName) {
  switch (iconName) {
    case 'est.svg':
      return AppPics.SideMenuDashboardSvg;
    default:
      return AppPics.SideMenuDashboardSvg;
  }
}

export default SideBar;
